import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export type AcceptedLegalDocuments = {
  dpa: Scalars['ID']['input'];
  sla: Scalars['ID']['input'];
};

export type AccessEvent = {
  __typename?: 'AccessEvent';
  action: MobileOpCode;
  createdAt: Scalars['AWSDateTime']['output'];
  door: AccessEventDoor;
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  visitor: AccessEventVisitor;
};

export type AccessEventDoor = {
  __typename?: 'AccessEventDoor';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<DoorType>;
};

export type AccessEventVisitor = {
  __typename?: 'AccessEventVisitor';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AccessEventsDateRange = {
  rangeEnd: Scalars['AWSDateTime']['input'];
  rangeStart: Scalars['AWSDateTime']['input'];
};

export type AccessEventsFilter = {
  actions?: InputMaybe<Array<InputMaybe<MobileOpCode>>>;
  dateRange?: InputMaybe<AccessEventsDateRange>;
  doorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  reason?: InputMaybe<Scalars['String']['input']>;
  visitorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AccessEventsPage = {
  __typename?: 'AccessEventsPage';
  items: Array<AccessEvent>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type AccessGrant = {
  __typename?: 'AccessGrant';
  accessSchedule: Schedule;
  /** Use `doorIds` for faster API responses if you don't need any nested fields from `doors` */
  doorIds: Array<Scalars['ID']['output']>;
  doors: Array<Door>;
  id: Scalars['ID']['output'];
  isOfficeModeEnabled: Scalars['Boolean']['output'];
  /** Use `locationIds` for faster API responses if you don't need any nested fields from `locations` */
  locationIds: Array<Scalars['ID']['output']>;
  locations: Array<Location>;
  name: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
};

export type AccessGrantOfficeModeInput = {
  accessGrantId: Scalars['ID']['input'];
  isOfficeModeEnabled: Scalars['Boolean']['input'];
};

export type AgreementRejected = {
  __typename?: 'AgreementRejected';
  reason: Scalars['String']['output'];
};

export type AgreementResult = AgreementRejected | BasicTenant;

export type Attendee = Guest | Host;

export type BasicTenant = {
  __typename?: 'BasicTenant';
  additionalData?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  onboardingStep: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
};

export type BlockedInfo = {
  __typename?: 'BlockedInfo';
  reason: Scalars['String']['output'];
  since: Scalars['AWSDateTime']['output'];
};

export type BulkAddVisitorsToVisitorGroupsInput = {
  /**
   * Every selected visitor is added to every listed group, with the given role and expiration date.
   * At most 100 memberships (visitors × groups) per request.
   */
  memberships: Array<VisitorGroupMembershipInput>;
  visitorIds: Array<Scalars['ID']['input']>;
};

export type BulkAssignVisitorRolesInput = {
  /** Assign-only: roles a visitor already has are kept, and bulk never removes a role. */
  roles: Array<VisitorRole>;
  visitorIds: Array<Scalars['ID']['input']>;
};

export type BulkDeleteVisitorsInput = {
  visitorIds: Array<Scalars['ID']['input']>;
};

/** Delete has no visitor left to return, so it reports ids instead of entities. */
export type BulkDeleteVisitorsPayload = {
  __typename?: 'BulkDeleteVisitorsPayload';
  deletedVisitorIds: Array<Scalars['ID']['output']>;
  errors: Array<BulkOperationError>;
};

export type BulkOperationEntity = {
  __typename?: 'BulkOperationEntity';
  entityId: Scalars['ID']['output'];
  entityType: BulkOperationEntityType;
};

export enum BulkOperationEntityType {
  Door = 'DOOR',
  Location = 'LOCATION',
  MobileDevice = 'MOBILE_DEVICE',
  Visitor = 'VISITOR',
  VisitorGroup = 'VISITOR_GROUP'
}

export type BulkOperationError = {
  __typename?: 'BulkOperationError';
  code: BulkOperationErrorCode;
  message?: Maybe<Scalars['String']['output']>;
  relatedEntities?: Maybe<Array<BulkOperationEntity>>;
  visitorId: Scalars['ID']['output'];
};

/** Extended once the possible bulk operation failures are known. */
export enum BulkOperationErrorCode {
  Unknown = 'UNKNOWN'
}

export type BulkResendVisitorInvitationsInput = {
  mobileDeviceIds: Array<Scalars['ID']['input']>;
};

export type BulkVisitorGroupTargetInput = {
  visitorGroupId: Scalars['ID']['input'];
};

export type BulkVisitorsPayload = {
  __typename?: 'BulkVisitorsPayload';
  /** Empty list means the whole operation succeeded. */
  errors: Array<BulkOperationError>;
  /** Full, updated state of every visitor the operation succeeded for. */
  updated: Array<Visitor>;
};

export type CloudController = {
  __typename?: 'CloudController';
  id: Scalars['ID']['output'];
  readers: Array<CloudControllerReader>;
  serialNumber: Scalars['String']['output'];
};

export type CloudControllerDoor = {
  __typename?: 'CloudControllerDoor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CloudControllerMutations = {
  __typename?: 'CloudControllerMutations';
  addDoor: CloudControllerDoor;
  identifyReader: Scalars['ID']['output'];
  openDoor: Scalars['ID']['output'];
  updateReaderFirmware: Scalars['String']['output'];
};


export type CloudControllerMutationsAddDoorArgs = {
  doorName: Scalars['String']['input'];
};


export type CloudControllerMutationsIdentifyReaderArgs = {
  doorId: Scalars['ID']['input'];
};


export type CloudControllerMutationsOpenDoorArgs = {
  doorId: Scalars['ID']['input'];
};


export type CloudControllerMutationsUpdateReaderFirmwareArgs = {
  doorId: Scalars['ID']['input'];
};

export type CloudControllerQueries = {
  __typename?: 'CloudControllerQueries';
  getCloudController: CloudController;
  getCloudControllers: Array<CloudController>;
  /** null when the door never had a reader firmware update. */
  getReaderFirmwareUpdate?: Maybe<ReaderFirmwareUpdate>;
};


export type CloudControllerQueriesGetCloudControllerArgs = {
  cloudControllerId: Scalars['ID']['input'];
};


export type CloudControllerQueriesGetReaderFirmwareUpdateArgs = {
  doorId: Scalars['ID']['input'];
};

export type CloudControllerReader = {
  __typename?: 'CloudControllerReader';
  cloudControllerId: Scalars['ID']['output'];
  /** null while the reader has no door. */
  doorId?: Maybe<Scalars['ID']['output']>;
  /** null when the reader never had a reader firmware update. */
  firmwareUpdate?: Maybe<ReaderFirmwareUpdate>;
  serialNumber: Scalars['String']['output'];
};

export type Door = {
  __typename?: 'Door';
  batteryWarningLevel: DoorBatteryWarningLevel;
  hardwareIdentifier: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Use `locationIds` for faster API responses if you don't need any nested fields from `locations` */
  locationIds: Array<Scalars['ID']['output']>;
  locations: Array<Location>;
  name: Scalars['String']['output'];
  officeMode: Schedule;
  supportsOssCards: Scalars['Boolean']['output'];
  taReaderId: Scalars['String']['output'];
  type: DoorType;
};

export enum DoorBatteryWarningLevel {
  BatteryCritical = 'BATTERY_CRITICAL',
  BatteryDefault = 'BATTERY_DEFAULT',
  BatteryEmpty = 'BATTERY_EMPTY',
  BatteryLow = 'BATTERY_LOW',
  BatteryUnknown = 'BATTERY_UNKNOWN',
  Powered = 'POWERED'
}

export enum DoorType {
  CloudControllerDoor = 'CLOUD_CONTROLLER_DOOR',
  DomController = 'DOM_CONTROLLER',
  DomCylinder = 'DOM_CYLINDER',
  DomHandle = 'DOM_HANDLE',
  DomLocker = 'DOM_LOCKER',
  DomReader = 'DOM_READER',
  Tanlock = 'TANLOCK'
}

export type DoorsFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GroupMembershipInput = {
  expirationDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  role: Role;
  visitorId: Scalars['ID']['input'];
};

export type Guest = Person & {
  __typename?: 'Guest';
  email: Scalars['AWSEmail']['output'];
  name: Scalars['String']['output'];
};

export type Host = Person & {
  __typename?: 'Host';
  azureId?: Maybe<Scalars['String']['output']>;
  azureTenantId?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['AWSEmail']['output'];
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  mobileDevices: Array<MobileDevice>;
  name: Scalars['String']['output'];
  visitorGroupMembership: Array<VisitorGroupMembership>;
};

export type IVisit = {
  accepted?: Maybe<Scalars['Boolean']['output']>;
  attendees: Array<Attendee>;
  dateEnd: Scalars['AWSDateTime']['output'];
  dateStart: Scalars['AWSDateTime']['output'];
  host: Host;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  source: VisitSource;
};

export type LegalDocument = {
  __typename?: 'LegalDocument';
  acceptedOn?: Maybe<Scalars['AWSDateTime']['output']>;
  acceptedVersion?: Maybe<Scalars['String']['output']>;
  currentText: Scalars['String']['output'];
  currentVersion: Scalars['String']['output'];
  documentType: LegalDocumentType;
  id: Scalars['ID']['output'];
};

export enum LegalDocumentType {
  Dpa = 'DPA',
  Sla = 'SLA'
}

export type Location = {
  __typename?: 'Location';
  /** Use `doorIds` for faster API responses if you don't need any nested fields from `doors` */
  doorIds: Array<Scalars['ID']['output']>;
  doors: Array<Door>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LocationInput = {
  doorIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** @deprecated This field is ignored. */
  type?: InputMaybe<LocationType>;
};

export enum LocationType {
  /** @deprecated No longer used. */
  External = 'EXTERNAL',
  /** @deprecated No longer used. */
  Manual = 'MANUAL'
}

export type LocationsFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum MemberDeleteOptions {
  /** All visitors with an INTERNAL or COGNITO Identity Provider */
  AtlasManagedVisitors = 'ATLAS_MANAGED_VISITORS',
  NoVisitors = 'NO_VISITORS',
  VisitorsWithoutOtherGroups = 'VISITORS_WITHOUT_OTHER_GROUPS'
}

export type MobileDevice = {
  __typename?: 'MobileDevice';
  id: Scalars['ID']['output'];
  isRegistered: Scalars['Boolean']['output'];
  registrationDate?: Maybe<Scalars['String']['output']>;
  registrationToken?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
};

export enum MobileOpCode {
  AccessDenied = 'ACCESS_DENIED',
  AccessGranted = 'ACCESS_GRANTED',
  BleConnectionRefused = 'BLE_CONNECTION_REFUSED',
  NonceNotCorrect = 'NONCE_NOT_CORRECT',
  NoResponseFromLock = 'NO_RESPONSE_FROM_LOCK',
  OpenCommandSend = 'OPEN_COMMAND_SEND',
  /** @deprecated Field no longer supported */
  Other = 'OTHER',
  ResultPending = 'RESULT_PENDING',
  TokenSendToLock = 'TOKEN_SEND_TO_LOCK',
  Unknown = 'UNKNOWN'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptLegalDocuments: AgreementResult;
  addAndRemoveVisitorGroupMemberships: Visitor;
  addLocation: Location;
  addRestApiKey: RestApiKey;
  addVisitor: Visitor;
  addVisitorGroup: VisitorGroup;
  addVisitorsToVisitorGroup: VisitorGroup;
  assignToAccessGrants: Array<AccessGrant>;
  blockNfcCard: NfcCard;
  bulkAddVisitorsToVisitorGroups: BulkVisitorsPayload;
  bulkAssignVisitorRoles: BulkVisitorsPayload;
  bulkDeleteVisitors: BulkDeleteVisitorsPayload;
  bulkResendVisitorInvitations: BulkVisitorsPayload;
  cloudController: CloudControllerMutations;
  deleteDoorById?: Maybe<Scalars['ID']['output']>;
  deleteLocation: Location;
  deleteQrCodeVisit: QrCodeVisitWeb;
  deleteRestApiKey: Scalars['ID']['output'];
  deleteVisitorById?: Maybe<Scalars['ID']['output']>;
  deleteVisitorGroupById?: Maybe<Scalars['ID']['output']>;
  goBackOneOnboardingStep: BasicTenant;
  onboardingChooseProvider: BasicTenant;
  registerAzureTenant: RegisterAzureTenantResult;
  resendVerificationCode?: Maybe<Scalars['Boolean']['output']>;
  sendInvitationForMobileDeviceById: Scalars['ID']['output'];
  setAccessGrantsIsOfficeModeEnabled: AccessGrant;
  setInstaller: Visitor;
  setIsAdminForGroup: VisitorGroup;
  setIsQrCodeVisitInviterForGroup: VisitorGroup;
  setMfaPreference: UserMfaPreference;
  setVisitor: Visitor;
  setVisitorById: Visitor;
  unassignFromAccessGrants: Array<AccessGrant>;
  unregisterMobileDeviceById: Scalars['ID']['output'];
  unsetInstallerById: Visitor;
  updateAccessGrant: AccessGrant;
  updateDoor: Door;
  updateLocation: Location;
  updateMembership: VisitorGroupMembership;
  updateRestApiKey: RestApiKey;
  updateVisitorGroup: VisitorGroup;
  updateVisitorGroupDetails: VisitorGroup;
  verifyAccount: BasicTenant;
};


export type MutationAcceptLegalDocumentsArgs = {
  acceptedLegalDocuments: AcceptedLegalDocuments;
};


export type MutationAddAndRemoveVisitorGroupMembershipsArgs = {
  add?: InputMaybe<Array<VisitorGroupMembershipInput>>;
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  visitorId: Scalars['ID']['input'];
};


export type MutationAddLocationArgs = {
  location: LocationInput;
};


export type MutationAddRestApiKeyArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddVisitorArgs = {
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  expirationDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  name: Scalars['String']['input'];
  visitorGroupExternalRefs?: InputMaybe<Array<Scalars['String']['input']>>;
  visitorGroupMembership?: InputMaybe<Array<VisitorGroupMembershipInput>>;
};


export type MutationAddVisitorGroupArgs = {
  maxNumberOfMembers?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationAddVisitorsToVisitorGroupArgs = {
  memberships: Array<GroupMembershipInput>;
  visitorGroupId: Scalars['ID']['input'];
};


export type MutationAssignToAccessGrantsArgs = {
  accessGrantIds: Array<Scalars['ID']['input']>;
  doorIds: Array<Scalars['ID']['input']>;
  locationIds: Array<Scalars['ID']['input']>;
};


export type MutationBlockNfcCardArgs = {
  reason: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};


export type MutationBulkAddVisitorsToVisitorGroupsArgs = {
  input: BulkAddVisitorsToVisitorGroupsInput;
};


export type MutationBulkAssignVisitorRolesArgs = {
  input: BulkAssignVisitorRolesInput;
};


export type MutationBulkDeleteVisitorsArgs = {
  input: BulkDeleteVisitorsInput;
};


export type MutationBulkResendVisitorInvitationsArgs = {
  input: BulkResendVisitorInvitationsInput;
};


export type MutationDeleteDoorByIdArgs = {
  doorId: Scalars['ID']['input'];
};


export type MutationDeleteLocationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteQrCodeVisitArgs = {
  qrCodeVisitId: Scalars['ID']['input'];
};


export type MutationDeleteRestApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVisitorByIdArgs = {
  visitorId: Scalars['ID']['input'];
};


export type MutationDeleteVisitorGroupByIdArgs = {
  options?: InputMaybe<MemberDeleteOptions>;
  visitorGroupId: Scalars['ID']['input'];
  withVisitors?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationOnboardingChooseProviderArgs = {
  provider: Provider;
};


export type MutationRegisterAzureTenantArgs = {
  input: RegisterAzureTenantInput;
};


export type MutationResendVerificationCodeArgs = {
  email: Scalars['AWSEmail']['input'];
};


export type MutationSendInvitationForMobileDeviceByIdArgs = {
  mobileDeviceId: Scalars['ID']['input'];
  visitorId: Scalars['ID']['input'];
};


export type MutationSetAccessGrantsIsOfficeModeEnabledArgs = {
  accessGrantId: Scalars['ID']['input'];
  isOfficeModeEnabled: Scalars['Boolean']['input'];
};


export type MutationSetInstallerArgs = {
  email: Scalars['AWSEmail']['input'];
  name: Scalars['String']['input'];
};


export type MutationSetIsAdminForGroupArgs = {
  isAdmin: Scalars['Boolean']['input'];
  visitorGroupId: Scalars['ID']['input'];
};


export type MutationSetIsQrCodeVisitInviterForGroupArgs = {
  isQrCodeVisitInviter: Scalars['Boolean']['input'];
  visitorGroupId: Scalars['ID']['input'];
};


export type MutationSetMfaPreferenceArgs = {
  emailMfaEnabled: Scalars['Boolean']['input'];
};


export type MutationSetVisitorArgs = {
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  expirationDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  name: Scalars['String']['input'];
  visitorGroupExternalRefs?: InputMaybe<Array<Scalars['String']['input']>>;
  visitorGroupMembership?: InputMaybe<Array<VisitorGroupMembershipInput>>;
};


export type MutationSetVisitorByIdArgs = {
  expirationDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  name: Scalars['String']['input'];
  visitorGroupExternalRefs?: InputMaybe<Array<Scalars['String']['input']>>;
  visitorGroupMembership?: InputMaybe<Array<VisitorGroupMembershipInput>>;
  visitorId: Scalars['ID']['input'];
};


export type MutationUnassignFromAccessGrantsArgs = {
  accessGrantIds: Array<Scalars['ID']['input']>;
  doorIds: Array<Scalars['ID']['input']>;
  locationIds: Array<Scalars['ID']['input']>;
};


export type MutationUnregisterMobileDeviceByIdArgs = {
  mobileDeviceId: Scalars['ID']['input'];
  visitorId: Scalars['ID']['input'];
};


export type MutationUnsetInstallerByIdArgs = {
  visitorId: Scalars['ID']['input'];
};


export type MutationUpdateAccessGrantArgs = {
  accessGrantId: Scalars['ID']['input'];
  input: UpdateAccessGrantInput;
};


export type MutationUpdateDoorArgs = {
  doorId: Scalars['ID']['input'];
  externalLocationId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  manualLocationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  officeMode?: InputMaybe<UpdateDoorOfficeModeInput>;
};


export type MutationUpdateLocationArgs = {
  id: Scalars['ID']['input'];
  location: LocationInput;
};


export type MutationUpdateMembershipArgs = {
  expirationDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  role?: InputMaybe<Role>;
  visitorGroupId: Scalars['ID']['input'];
  visitorId: Scalars['ID']['input'];
};


export type MutationUpdateRestApiKeyArgs = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateVisitorGroupArgs = {
  maxNumberOfMembers?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  visitorGroupId: Scalars['ID']['input'];
};


export type MutationUpdateVisitorGroupDetailsArgs = {
  input: UpdateVisitorGroupDetailsInput;
};


export type MutationVerifyAccountArgs = {
  code: Scalars['String']['input'];
  email: Scalars['AWSEmail']['input'];
};

export type NfcCard = {
  __typename?: 'NfcCard';
  /** When field is Null, card is not assigned to a visitor */
  assignment?: Maybe<NfcCardAssignment>;
  /** The same as the visual identifier on the card */
  name: Scalars['String']['output'];
  updateRequired: Scalars['Boolean']['output'];
  uuid: Scalars['ID']['output'];
};

export type NfcCardAssignment = {
  __typename?: 'NfcCardAssignment';
  /** Null means the card is not blocked */
  blocked?: Maybe<BlockedInfo>;
  expired: Scalars['Boolean']['output'];
  expiryDate: Scalars['AWSDateTime']['output'];
  /** Null when visitor has been deleted */
  visitor?: Maybe<Visitor>;
  /** Contains name even when visitor deleted */
  visitorName: Scalars['String']['output'];
};

export type Participant = {
  email: Scalars['AWSEmail']['input'];
  name: Scalars['String']['input'];
};

export type Person = {
  email: Scalars['AWSEmail']['output'];
  name: Scalars['String']['output'];
};

export enum Provider {
  Cognito = 'COGNITO',
  Entra = 'ENTRA'
}

export enum QrCodeVisitStatus {
  Cancelled = 'CANCELLED',
  Used = 'USED',
  Valid = 'VALID'
}

export type QrCodeVisitWeb = {
  __typename?: 'QrCodeVisitWeb';
  datetime: Scalars['AWSDateTime']['output'];
  email?: Maybe<Scalars['AWSEmail']['output']>;
  host: Visitor;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<QrCodeVisitStatus>;
};

export type Query = {
  __typename?: 'Query';
  cloudController: CloudControllerQueries;
  getAccessEventsForTenant: AccessEventsPage;
  getCurrentTenant: BasicTenant;
  getCurrentVisitor: Visitor;
  getDoorsForTenant: Array<Door>;
  getLocationsForTenant: Array<Location>;
  getMfaPreference: UserMfaPreference;
  getNfcCards: Array<NfcCard>;
  getQrCodeVisitsForTenant: Array<QrCodeVisitWeb>;
  getRestApiKeys: Array<RestApiKey>;
  getTenantLegalDocuments: TenantLegalDocuments;
  getTenantName: Scalars['String']['output'];
  getTenantRegistrationInfo: TenantRegistrationInfo;
  getVisitorById: Visitor;
  getVisitorGroupsForTenant: Array<VisitorGroup>;
  getVisitors: Array<Visitor>;
};


export type QueryGetAccessEventsForTenantArgs = {
  filter?: InputMaybe<AccessEventsFilter>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDoorsForTenantArgs = {
  filter?: InputMaybe<DoorsFilter>;
};


export type QueryGetLocationsForTenantArgs = {
  filter?: InputMaybe<LocationsFilter>;
};


export type QueryGetTenantNameArgs = {
  azureTenantId: Scalars['String']['input'];
};


export type QueryGetVisitorByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVisitorGroupsForTenantArgs = {
  filter?: InputMaybe<VisitorGroupsFilter>;
};


export type QueryGetVisitorsArgs = {
  filter?: InputMaybe<VisitorsFilter>;
};

export type ReaderFirmwareUpdate = {
  __typename?: 'ReaderFirmwareUpdate';
  doorId: Scalars['ID']['output'];
  /** 0 to 100 */
  percentage: Scalars['Int']['output'];
  status: ReaderFirmwareUpdateStatus;
  tenantId: Scalars['ID']['output'];
};

export enum ReaderFirmwareUpdateStatus {
  Canceled = 'CANCELED',
  Downloading = 'DOWNLOADING',
  Failed = 'FAILED',
  Installing = 'INSTALLING',
  Queued = 'QUEUED',
  Rejected = 'REJECTED',
  Removed = 'REMOVED',
  Succeeded = 'SUCCEEDED',
  TimedOut = 'TIMED_OUT'
}

export type RegisterAzureTenantInput = {
  azureTenantId: Scalars['ID']['input'];
};

export type RegisterAzureTenantResult = {
  __typename?: 'RegisterAzureTenantResult';
  tenantId: Scalars['ID']['output'];
};

export type RestApiKey = {
  __typename?: 'RestApiKey';
  apiKey: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tenantId: Scalars['ID']['output'];
};

export enum Role {
  ExternalGroupUser = 'EXTERNAL_GROUP_USER',
  ExternalGroupUserManager = 'EXTERNAL_GROUP_USER_MANAGER',
  None = 'NONE'
}

export type Schedule = WeekSchedule;

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Subscription = {
  __typename?: 'Subscription';
  /** @deprecated Use onMobileDeviceRegisteredById to use visitorId instead of email */
  onMobileDeviceRegistered?: Maybe<SubscriptionMobileDevice>;
  onMobileDeviceRegisteredById?: Maybe<SubscriptionMobileDeviceById>;
  onReaderFirmwareUpdate?: Maybe<ReaderFirmwareUpdate>;
  /** @deprecated Use onRegistrationTokenSavedById to use visitorId instead of email */
  onRegistrationTokenSaved?: Maybe<SubscriptionRegistrationTokenSaved>;
  onRegistrationTokenSavedById?: Maybe<SubscriptionRegistrationTokenSavedById>;
};


export type SubscriptionOnMobileDeviceRegisteredArgs = {
  email: Scalars['AWSEmail']['input'];
};


export type SubscriptionOnMobileDeviceRegisteredByIdArgs = {
  visitorId: Scalars['ID']['input'];
};


export type SubscriptionOnReaderFirmwareUpdateArgs = {
  doorId: Scalars['ID']['input'];
};


export type SubscriptionOnRegistrationTokenSavedArgs = {
  email: Scalars['AWSEmail']['input'];
};


export type SubscriptionOnRegistrationTokenSavedByIdArgs = {
  visitorId: Scalars['ID']['input'];
};

export type SubscriptionMobileDevice = {
  __typename?: 'SubscriptionMobileDevice';
  email: Scalars['AWSEmail']['output'];
  registrationDate: Scalars['AWSDateTime']['output'];
};

export type SubscriptionMobileDeviceById = {
  __typename?: 'SubscriptionMobileDeviceById';
  mobileDeviceId: Scalars['ID']['output'];
  registrationDate: Scalars['AWSDateTime']['output'];
  visitorId: Scalars['ID']['output'];
};

export type SubscriptionRegistrationTokenSaved = {
  __typename?: 'SubscriptionRegistrationTokenSaved';
  email: Scalars['AWSEmail']['output'];
  registrationToken: Scalars['String']['output'];
};

export type SubscriptionRegistrationTokenSavedById = {
  __typename?: 'SubscriptionRegistrationTokenSavedById';
  mobileDeviceId: Scalars['ID']['output'];
  registrationToken: Scalars['String']['output'];
  visitorId: Scalars['ID']['output'];
};

export type SubscriptionRemovedVisit = {
  __typename?: 'SubscriptionRemovedVisit';
  email: Scalars['AWSEmail']['output'];
  id: Scalars['ID']['output'];
};

export type SubscriptionVisit = IVisit & {
  __typename?: 'SubscriptionVisit';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  attendees: Array<Attendee>;
  dateEnd: Scalars['AWSDateTime']['output'];
  dateStart: Scalars['AWSDateTime']['output'];
  email: Scalars['AWSEmail']['output'];
  hasAttendees: Scalars['Boolean']['output'];
  host: Host;
  id: Scalars['ID']['output'];
  isPastVisit: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  source: VisitSource;
};

export type TenantLegalDocuments = {
  __typename?: 'TenantLegalDocuments';
  dpa: LegalDocument;
  sla: LegalDocument;
  tenant: BasicTenant;
};

export type TenantRegistrationInfo = {
  __typename?: 'TenantRegistrationInfo';
  azureTenantId?: Maybe<Scalars['ID']['output']>;
  entraAdminConsentUrl?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['ID']['output'];
};

export type UpdateAccessGrantInput = {
  scheduleType: Scalars['String']['input'];
  weekSchedule: Array<WeekScheduleDayInput>;
};

export type UpdateDoorOfficeModeInput = {
  scheduleType: Scalars['String']['input'];
  weekSchedule: Array<WeekScheduleDayInput>;
};

export type UpdateVisitorGroupDetailsInput = {
  isQrCodeVisitInviter?: InputMaybe<Scalars['Boolean']['input']>;
  maxNumberOfMembers?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  officeMode?: InputMaybe<AccessGrantOfficeModeInput>;
  visitorGroupId: Scalars['ID']['input'];
};

export enum UserIdentityProvider {
  Cognito = 'COGNITO',
  Entra = 'ENTRA',
  Internal = 'INTERNAL'
}

export type UserMfaPreference = {
  __typename?: 'UserMfaPreference';
  emailMfaEnabled: Scalars['Boolean']['output'];
};

export type Visit = IVisit & {
  __typename?: 'Visit';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  attendees: Array<Attendee>;
  dateEnd: Scalars['AWSDateTime']['output'];
  dateStart: Scalars['AWSDateTime']['output'];
  host: Host;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  source: VisitSource;
};

export type VisitInput = {
  attendees: Array<Participant>;
  azureId?: InputMaybe<Scalars['ID']['input']>;
  dateEnd: Scalars['AWSDateTime']['input'];
  dateStart: Scalars['AWSDateTime']['input'];
  hostEmail: Scalars['AWSEmail']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
};

export enum VisitSource {
  Internal = 'internal',
  Outlook = 'outlook'
}

export type Visitor = {
  __typename?: 'Visitor';
  email?: Maybe<Scalars['AWSEmail']['output']>;
  /** @deprecated Expiration is now per group membership. Use `expirationDate` on `visitorGroupMembership` instead. */
  expirationDate?: Maybe<Scalars['AWSDateTime']['output']>;
  externalRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identityProvider: UserIdentityProvider;
  isAdmin: Scalars['Boolean']['output'];
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  isQrCodeVisitInviter: Scalars['Boolean']['output'];
  mobileDevices: Array<MobileDevice>;
  name: Scalars['String']['output'];
  tenantId: Scalars['ID']['output'];
  visitorGroupMembership: Array<VisitorGroupMembership>;
};

export type VisitorGroup = {
  __typename?: 'VisitorGroup';
  accessGrants: Array<AccessGrant>;
  /** @deprecated No longer used and will always be empty. */
  allowedAccessGrants: Array<AccessGrant>;
  /** @deprecated No longer used and will always be empty. */
  defaultAccessGrants: Array<AccessGrant>;
  externalRef: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAdminGroup: Scalars['Boolean']['output'];
  isQrCodeVisitInviterGroup: Scalars['Boolean']['output'];
  maxNumberOfMembers?: Maybe<Scalars['Int']['output']>;
  /** Use `memberIds` for faster API responses if you don't need any nested fields from `members` */
  memberIds: Array<Scalars['ID']['output']>;
  members: Array<Visitor>;
  name: Scalars['String']['output'];
  /** @deprecated Field has been renamed to accessGrants. */
  scheduledAccessGrants: Array<AccessGrant>;
  tenantId: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type VisitorGroupMembership = {
  __typename?: 'VisitorGroupMembership';
  /** When set, the visitor's membership of this group expires at this date/time. Temporary visitors are expired per group membership. */
  expirationDate?: Maybe<Scalars['AWSDateTime']['output']>;
  role: Role;
  visitorGroup: VisitorGroup;
};

export type VisitorGroupMembershipInput = {
  /** When set, the visitor's membership of this group expires at this date/time. Use this instead of the visitor-level `expirationDate`. */
  expirationDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  role: Role;
  /** @deprecated Use `visitorGroupId` */
  visitorGroupExternalRef?: InputMaybe<Scalars['String']['input']>;
  visitorGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type VisitorGroupsFilter = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type VisitorInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visitorGroupExternalRefs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum VisitorRole {
  Admin = 'ADMIN',
  Installer = 'INSTALLER'
}

export type VisitorsFilter = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  visitorGroupId?: InputMaybe<Scalars['String']['input']>;
};

export type VisitsDateRange = {
  rangeEnd?: InputMaybe<Scalars['AWSDateTime']['input']>;
  rangeStart: Scalars['AWSDateTime']['input'];
};

export type VisitsFilter = {
  dateRange?: InputMaybe<VisitsDateRange>;
  hasAttendees?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VisitsPage = {
  __typename?: 'VisitsPage';
  items: Array<Visit>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type VisitsSort = {
  direction: SortDirection;
  field: VisitsSortFields;
};

export enum VisitsSortFields {
  DateStart = 'DATE_START'
}

export type WeekSchedule = {
  __typename?: 'WeekSchedule';
  weekDays: Array<WeekScheduleDay>;
};

export type WeekScheduleDay = {
  __typename?: 'WeekScheduleDay';
  dayName: Scalars['String']['output'];
  from: Scalars['String']['output'];
  to: Scalars['String']['output'];
};

export type WeekScheduleDayInput = {
  dayName: Scalars['String']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  AgreementResult: ( AgreementRejected ) | ( BasicTenant );
  Attendee: ( Guest ) | ( Omit<Host, 'mobileDevices' | 'visitorGroupMembership'> & { mobileDevices: Array<_RefType['MobileDevice']>, visitorGroupMembership: Array<_RefType['VisitorGroupMembership']> } );
  Schedule: ( WeekSchedule );
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  IVisit: ( Omit<SubscriptionVisit, 'attendees' | 'host'> & { attendees: Array<_RefType['Attendee']>, host: _RefType['Host'] } ) | ( Omit<Visit, 'attendees' | 'host'> & { attendees: Array<_RefType['Attendee']>, host: _RefType['Host'] } );
  Person: ( Guest ) | ( Omit<Host, 'mobileDevices' | 'visitorGroupMembership'> & { mobileDevices: Array<_RefType['MobileDevice']>, visitorGroupMembership: Array<_RefType['VisitorGroupMembership']> } );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AWSDate: ResolverTypeWrapper<Scalars['AWSDate']['output']>;
  AWSDateTime: ResolverTypeWrapper<Scalars['AWSDateTime']['output']>;
  AWSEmail: ResolverTypeWrapper<Scalars['AWSEmail']['output']>;
  AWSIPAddress: ResolverTypeWrapper<Scalars['AWSIPAddress']['output']>;
  AWSJSON: ResolverTypeWrapper<Scalars['AWSJSON']['output']>;
  AWSPhone: ResolverTypeWrapper<Scalars['AWSPhone']['output']>;
  AWSTime: ResolverTypeWrapper<Scalars['AWSTime']['output']>;
  AWSTimestamp: ResolverTypeWrapper<Scalars['AWSTimestamp']['output']>;
  AWSURL: ResolverTypeWrapper<Scalars['AWSURL']['output']>;
  AcceptedLegalDocuments: AcceptedLegalDocuments;
  AccessEvent: ResolverTypeWrapper<AccessEvent>;
  AccessEventDoor: ResolverTypeWrapper<AccessEventDoor>;
  AccessEventVisitor: ResolverTypeWrapper<AccessEventVisitor>;
  AccessEventsDateRange: AccessEventsDateRange;
  AccessEventsFilter: AccessEventsFilter;
  AccessEventsPage: ResolverTypeWrapper<AccessEventsPage>;
  AccessGrant: ResolverTypeWrapper<Omit<AccessGrant, 'accessSchedule' | 'doors' | 'locations'> & { accessSchedule: ResolversTypes['Schedule'], doors: Array<ResolversTypes['Door']>, locations: Array<ResolversTypes['Location']> }>;
  AccessGrantOfficeModeInput: AccessGrantOfficeModeInput;
  AgreementRejected: ResolverTypeWrapper<AgreementRejected>;
  AgreementResult: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AgreementResult']>;
  Attendee: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Attendee']>;
  BasicTenant: ResolverTypeWrapper<BasicTenant>;
  BlockedInfo: ResolverTypeWrapper<BlockedInfo>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  BulkAddVisitorsToVisitorGroupsInput: BulkAddVisitorsToVisitorGroupsInput;
  BulkAssignVisitorRolesInput: BulkAssignVisitorRolesInput;
  BulkDeleteVisitorsInput: BulkDeleteVisitorsInput;
  BulkDeleteVisitorsPayload: ResolverTypeWrapper<BulkDeleteVisitorsPayload>;
  BulkOperationEntity: ResolverTypeWrapper<BulkOperationEntity>;
  BulkOperationEntityType: BulkOperationEntityType;
  BulkOperationError: ResolverTypeWrapper<BulkOperationError>;
  BulkOperationErrorCode: BulkOperationErrorCode;
  BulkResendVisitorInvitationsInput: BulkResendVisitorInvitationsInput;
  BulkVisitorGroupTargetInput: BulkVisitorGroupTargetInput;
  BulkVisitorsPayload: ResolverTypeWrapper<Omit<BulkVisitorsPayload, 'updated'> & { updated: Array<ResolversTypes['Visitor']> }>;
  CloudController: ResolverTypeWrapper<CloudController>;
  CloudControllerDoor: ResolverTypeWrapper<CloudControllerDoor>;
  CloudControllerMutations: ResolverTypeWrapper<CloudControllerMutations>;
  CloudControllerQueries: ResolverTypeWrapper<CloudControllerQueries>;
  CloudControllerReader: ResolverTypeWrapper<CloudControllerReader>;
  Door: ResolverTypeWrapper<Omit<Door, 'locations' | 'officeMode'> & { locations: Array<ResolversTypes['Location']>, officeMode: ResolversTypes['Schedule'] }>;
  DoorBatteryWarningLevel: DoorBatteryWarningLevel;
  DoorType: DoorType;
  DoorsFilter: DoorsFilter;
  GroupMembershipInput: GroupMembershipInput;
  Guest: ResolverTypeWrapper<Guest>;
  Host: ResolverTypeWrapper<Omit<Host, 'mobileDevices' | 'visitorGroupMembership'> & { mobileDevices: Array<ResolversTypes['MobileDevice']>, visitorGroupMembership: Array<ResolversTypes['VisitorGroupMembership']> }>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  IVisit: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['IVisit']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  LegalDocument: ResolverTypeWrapper<LegalDocument>;
  LegalDocumentType: LegalDocumentType;
  Location: ResolverTypeWrapper<Omit<Location, 'doors'> & { doors: Array<ResolversTypes['Door']> }>;
  LocationInput: LocationInput;
  LocationType: LocationType;
  LocationsFilter: LocationsFilter;
  MemberDeleteOptions: MemberDeleteOptions;
  MobileDevice: ResolverTypeWrapper<MobileDevice>;
  MobileOpCode: MobileOpCode;
  Mutation: ResolverTypeWrapper<{}>;
  NfcCard: ResolverTypeWrapper<Omit<NfcCard, 'assignment'> & { assignment?: Maybe<ResolversTypes['NfcCardAssignment']> }>;
  NfcCardAssignment: ResolverTypeWrapper<Omit<NfcCardAssignment, 'blocked' | 'visitor'> & { blocked?: Maybe<ResolversTypes['BlockedInfo']>, visitor?: Maybe<ResolversTypes['Visitor']> }>;
  Participant: Participant;
  Person: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Person']>;
  Provider: Provider;
  QrCodeVisitStatus: QrCodeVisitStatus;
  QrCodeVisitWeb: ResolverTypeWrapper<Omit<QrCodeVisitWeb, 'host'> & { host: ResolversTypes['Visitor'] }>;
  Query: ResolverTypeWrapper<{}>;
  ReaderFirmwareUpdate: ResolverTypeWrapper<ReaderFirmwareUpdate>;
  ReaderFirmwareUpdateStatus: ReaderFirmwareUpdateStatus;
  RegisterAzureTenantInput: RegisterAzureTenantInput;
  RegisterAzureTenantResult: ResolverTypeWrapper<RegisterAzureTenantResult>;
  RestApiKey: ResolverTypeWrapper<RestApiKey>;
  Role: Role;
  Schedule: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['Schedule']>;
  SortDirection: SortDirection;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Subscription: ResolverTypeWrapper<{}>;
  SubscriptionMobileDevice: ResolverTypeWrapper<SubscriptionMobileDevice>;
  SubscriptionMobileDeviceById: ResolverTypeWrapper<SubscriptionMobileDeviceById>;
  SubscriptionRegistrationTokenSaved: ResolverTypeWrapper<SubscriptionRegistrationTokenSaved>;
  SubscriptionRegistrationTokenSavedById: ResolverTypeWrapper<SubscriptionRegistrationTokenSavedById>;
  SubscriptionRemovedVisit: ResolverTypeWrapper<SubscriptionRemovedVisit>;
  SubscriptionVisit: ResolverTypeWrapper<Omit<SubscriptionVisit, 'attendees' | 'host'> & { attendees: Array<ResolversTypes['Attendee']>, host: ResolversTypes['Host'] }>;
  TenantLegalDocuments: ResolverTypeWrapper<TenantLegalDocuments>;
  TenantRegistrationInfo: ResolverTypeWrapper<TenantRegistrationInfo>;
  UpdateAccessGrantInput: UpdateAccessGrantInput;
  UpdateDoorOfficeModeInput: UpdateDoorOfficeModeInput;
  UpdateVisitorGroupDetailsInput: UpdateVisitorGroupDetailsInput;
  UserIdentityProvider: UserIdentityProvider;
  UserMfaPreference: ResolverTypeWrapper<UserMfaPreference>;
  Visit: ResolverTypeWrapper<Omit<Visit, 'attendees' | 'host'> & { attendees: Array<ResolversTypes['Attendee']>, host: ResolversTypes['Host'] }>;
  VisitInput: VisitInput;
  VisitSource: VisitSource;
  Visitor: ResolverTypeWrapper<Omit<Visitor, 'mobileDevices' | 'visitorGroupMembership'> & { mobileDevices: Array<ResolversTypes['MobileDevice']>, visitorGroupMembership: Array<ResolversTypes['VisitorGroupMembership']> }>;
  VisitorGroup: ResolverTypeWrapper<Omit<VisitorGroup, 'accessGrants' | 'allowedAccessGrants' | 'defaultAccessGrants' | 'members' | 'scheduledAccessGrants'> & { accessGrants: Array<ResolversTypes['AccessGrant']>, allowedAccessGrants: Array<ResolversTypes['AccessGrant']>, defaultAccessGrants: Array<ResolversTypes['AccessGrant']>, members: Array<ResolversTypes['Visitor']>, scheduledAccessGrants: Array<ResolversTypes['AccessGrant']> }>;
  VisitorGroupMembership: ResolverTypeWrapper<Omit<VisitorGroupMembership, 'visitorGroup'> & { visitorGroup: ResolversTypes['VisitorGroup'] }>;
  VisitorGroupMembershipInput: VisitorGroupMembershipInput;
  VisitorGroupsFilter: VisitorGroupsFilter;
  VisitorInput: VisitorInput;
  VisitorRole: VisitorRole;
  VisitorsFilter: VisitorsFilter;
  VisitsDateRange: VisitsDateRange;
  VisitsFilter: VisitsFilter;
  VisitsPage: ResolverTypeWrapper<Omit<VisitsPage, 'items'> & { items: Array<ResolversTypes['Visit']> }>;
  VisitsSort: VisitsSort;
  VisitsSortFields: VisitsSortFields;
  WeekSchedule: ResolverTypeWrapper<WeekSchedule>;
  WeekScheduleDay: ResolverTypeWrapper<WeekScheduleDay>;
  WeekScheduleDayInput: WeekScheduleDayInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AWSDate: Scalars['AWSDate']['output'];
  AWSDateTime: Scalars['AWSDateTime']['output'];
  AWSEmail: Scalars['AWSEmail']['output'];
  AWSIPAddress: Scalars['AWSIPAddress']['output'];
  AWSJSON: Scalars['AWSJSON']['output'];
  AWSPhone: Scalars['AWSPhone']['output'];
  AWSTime: Scalars['AWSTime']['output'];
  AWSTimestamp: Scalars['AWSTimestamp']['output'];
  AWSURL: Scalars['AWSURL']['output'];
  AcceptedLegalDocuments: AcceptedLegalDocuments;
  AccessEvent: AccessEvent;
  AccessEventDoor: AccessEventDoor;
  AccessEventVisitor: AccessEventVisitor;
  AccessEventsDateRange: AccessEventsDateRange;
  AccessEventsFilter: AccessEventsFilter;
  AccessEventsPage: AccessEventsPage;
  AccessGrant: Omit<AccessGrant, 'accessSchedule' | 'doors' | 'locations'> & { accessSchedule: ResolversParentTypes['Schedule'], doors: Array<ResolversParentTypes['Door']>, locations: Array<ResolversParentTypes['Location']> };
  AccessGrantOfficeModeInput: AccessGrantOfficeModeInput;
  AgreementRejected: AgreementRejected;
  AgreementResult: ResolversUnionTypes<ResolversParentTypes>['AgreementResult'];
  Attendee: ResolversUnionTypes<ResolversParentTypes>['Attendee'];
  BasicTenant: BasicTenant;
  BlockedInfo: BlockedInfo;
  Boolean: Scalars['Boolean']['output'];
  BulkAddVisitorsToVisitorGroupsInput: BulkAddVisitorsToVisitorGroupsInput;
  BulkAssignVisitorRolesInput: BulkAssignVisitorRolesInput;
  BulkDeleteVisitorsInput: BulkDeleteVisitorsInput;
  BulkDeleteVisitorsPayload: BulkDeleteVisitorsPayload;
  BulkOperationEntity: BulkOperationEntity;
  BulkOperationError: BulkOperationError;
  BulkResendVisitorInvitationsInput: BulkResendVisitorInvitationsInput;
  BulkVisitorGroupTargetInput: BulkVisitorGroupTargetInput;
  BulkVisitorsPayload: Omit<BulkVisitorsPayload, 'updated'> & { updated: Array<ResolversParentTypes['Visitor']> };
  CloudController: CloudController;
  CloudControllerDoor: CloudControllerDoor;
  CloudControllerMutations: CloudControllerMutations;
  CloudControllerQueries: CloudControllerQueries;
  CloudControllerReader: CloudControllerReader;
  Door: Omit<Door, 'locations' | 'officeMode'> & { locations: Array<ResolversParentTypes['Location']>, officeMode: ResolversParentTypes['Schedule'] };
  DoorsFilter: DoorsFilter;
  GroupMembershipInput: GroupMembershipInput;
  Guest: Guest;
  Host: Omit<Host, 'mobileDevices' | 'visitorGroupMembership'> & { mobileDevices: Array<ResolversParentTypes['MobileDevice']>, visitorGroupMembership: Array<ResolversParentTypes['VisitorGroupMembership']> };
  ID: Scalars['ID']['output'];
  IVisit: ResolversInterfaceTypes<ResolversParentTypes>['IVisit'];
  Int: Scalars['Int']['output'];
  LegalDocument: LegalDocument;
  Location: Omit<Location, 'doors'> & { doors: Array<ResolversParentTypes['Door']> };
  LocationInput: LocationInput;
  LocationsFilter: LocationsFilter;
  MobileDevice: MobileDevice;
  Mutation: {};
  NfcCard: Omit<NfcCard, 'assignment'> & { assignment?: Maybe<ResolversParentTypes['NfcCardAssignment']> };
  NfcCardAssignment: Omit<NfcCardAssignment, 'blocked' | 'visitor'> & { blocked?: Maybe<ResolversParentTypes['BlockedInfo']>, visitor?: Maybe<ResolversParentTypes['Visitor']> };
  Participant: Participant;
  Person: ResolversInterfaceTypes<ResolversParentTypes>['Person'];
  QrCodeVisitWeb: Omit<QrCodeVisitWeb, 'host'> & { host: ResolversParentTypes['Visitor'] };
  Query: {};
  ReaderFirmwareUpdate: ReaderFirmwareUpdate;
  RegisterAzureTenantInput: RegisterAzureTenantInput;
  RegisterAzureTenantResult: RegisterAzureTenantResult;
  RestApiKey: RestApiKey;
  Schedule: ResolversUnionTypes<ResolversParentTypes>['Schedule'];
  String: Scalars['String']['output'];
  Subscription: {};
  SubscriptionMobileDevice: SubscriptionMobileDevice;
  SubscriptionMobileDeviceById: SubscriptionMobileDeviceById;
  SubscriptionRegistrationTokenSaved: SubscriptionRegistrationTokenSaved;
  SubscriptionRegistrationTokenSavedById: SubscriptionRegistrationTokenSavedById;
  SubscriptionRemovedVisit: SubscriptionRemovedVisit;
  SubscriptionVisit: Omit<SubscriptionVisit, 'attendees' | 'host'> & { attendees: Array<ResolversParentTypes['Attendee']>, host: ResolversParentTypes['Host'] };
  TenantLegalDocuments: TenantLegalDocuments;
  TenantRegistrationInfo: TenantRegistrationInfo;
  UpdateAccessGrantInput: UpdateAccessGrantInput;
  UpdateDoorOfficeModeInput: UpdateDoorOfficeModeInput;
  UpdateVisitorGroupDetailsInput: UpdateVisitorGroupDetailsInput;
  UserMfaPreference: UserMfaPreference;
  Visit: Omit<Visit, 'attendees' | 'host'> & { attendees: Array<ResolversParentTypes['Attendee']>, host: ResolversParentTypes['Host'] };
  VisitInput: VisitInput;
  Visitor: Omit<Visitor, 'mobileDevices' | 'visitorGroupMembership'> & { mobileDevices: Array<ResolversParentTypes['MobileDevice']>, visitorGroupMembership: Array<ResolversParentTypes['VisitorGroupMembership']> };
  VisitorGroup: Omit<VisitorGroup, 'accessGrants' | 'allowedAccessGrants' | 'defaultAccessGrants' | 'members' | 'scheduledAccessGrants'> & { accessGrants: Array<ResolversParentTypes['AccessGrant']>, allowedAccessGrants: Array<ResolversParentTypes['AccessGrant']>, defaultAccessGrants: Array<ResolversParentTypes['AccessGrant']>, members: Array<ResolversParentTypes['Visitor']>, scheduledAccessGrants: Array<ResolversParentTypes['AccessGrant']> };
  VisitorGroupMembership: Omit<VisitorGroupMembership, 'visitorGroup'> & { visitorGroup: ResolversParentTypes['VisitorGroup'] };
  VisitorGroupMembershipInput: VisitorGroupMembershipInput;
  VisitorGroupsFilter: VisitorGroupsFilter;
  VisitorInput: VisitorInput;
  VisitorsFilter: VisitorsFilter;
  VisitsDateRange: VisitsDateRange;
  VisitsFilter: VisitsFilter;
  VisitsPage: Omit<VisitsPage, 'items'> & { items: Array<ResolversParentTypes['Visit']> };
  VisitsSort: VisitsSort;
  WeekSchedule: WeekSchedule;
  WeekScheduleDay: WeekScheduleDay;
  WeekScheduleDayInput: WeekScheduleDayInput;
};

export interface AwsDateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDate'], any> {
  name: 'AWSDate';
}

export interface AwsDateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSDateTime'], any> {
  name: 'AWSDateTime';
}

export interface AwsEmailScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSEmail'], any> {
  name: 'AWSEmail';
}

export interface AwsipAddressScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSIPAddress'], any> {
  name: 'AWSIPAddress';
}

export interface AwsjsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSJSON'], any> {
  name: 'AWSJSON';
}

export interface AwsPhoneScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSPhone'], any> {
  name: 'AWSPhone';
}

export interface AwsTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSTime'], any> {
  name: 'AWSTime';
}

export interface AwsTimestampScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSTimestamp'], any> {
  name: 'AWSTimestamp';
}

export interface AwsurlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['AWSURL'], any> {
  name: 'AWSURL';
}

export type AccessEventResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessEvent'] = ResolversParentTypes['AccessEvent']> = {
  action?: Resolver<ResolversTypes['MobileOpCode'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  door?: Resolver<ResolversTypes['AccessEventDoor'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  visitor?: Resolver<ResolversTypes['AccessEventVisitor'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessEventDoorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessEventDoor'] = ResolversParentTypes['AccessEventDoor']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['DoorType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessEventVisitorResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessEventVisitor'] = ResolversParentTypes['AccessEventVisitor']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessEventsPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessEventsPage'] = ResolversParentTypes['AccessEventsPage']> = {
  items?: Resolver<Array<ResolversTypes['AccessEvent']>, ParentType, ContextType>;
  nextToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccessGrantResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccessGrant'] = ResolversParentTypes['AccessGrant']> = {
  accessSchedule?: Resolver<ResolversTypes['Schedule'], ParentType, ContextType>;
  doorIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  doors?: Resolver<Array<ResolversTypes['Door']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isOfficeModeEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  locationIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  locations?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementRejectedResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementRejected'] = ResolversParentTypes['AgreementRejected']> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AgreementResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementResult'] = ResolversParentTypes['AgreementResult']> = {
  __resolveType: TypeResolveFn<'AgreementRejected' | 'BasicTenant', ParentType, ContextType>;
};

export type AttendeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attendee'] = ResolversParentTypes['Attendee']> = {
  __resolveType: TypeResolveFn<'Guest' | 'Host', ParentType, ContextType>;
};

export type BasicTenantResolvers<ContextType = any, ParentType extends ResolversParentTypes['BasicTenant'] = ResolversParentTypes['BasicTenant']> = {
  additionalData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onboardingStep?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlockedInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockedInfo'] = ResolversParentTypes['BlockedInfo']> = {
  reason?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  since?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkDeleteVisitorsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkDeleteVisitorsPayload'] = ResolversParentTypes['BulkDeleteVisitorsPayload']> = {
  deletedVisitorIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  errors?: Resolver<Array<ResolversTypes['BulkOperationError']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkOperationEntityResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkOperationEntity'] = ResolversParentTypes['BulkOperationEntity']> = {
  entityId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  entityType?: Resolver<ResolversTypes['BulkOperationEntityType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkOperationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkOperationError'] = ResolversParentTypes['BulkOperationError']> = {
  code?: Resolver<ResolversTypes['BulkOperationErrorCode'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relatedEntities?: Resolver<Maybe<Array<ResolversTypes['BulkOperationEntity']>>, ParentType, ContextType>;
  visitorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BulkVisitorsPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkVisitorsPayload'] = ResolversParentTypes['BulkVisitorsPayload']> = {
  errors?: Resolver<Array<ResolversTypes['BulkOperationError']>, ParentType, ContextType>;
  updated?: Resolver<Array<ResolversTypes['Visitor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudControllerResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloudController'] = ResolversParentTypes['CloudController']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  readers?: Resolver<Array<ResolversTypes['CloudControllerReader']>, ParentType, ContextType>;
  serialNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudControllerDoorResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloudControllerDoor'] = ResolversParentTypes['CloudControllerDoor']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudControllerMutationsResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloudControllerMutations'] = ResolversParentTypes['CloudControllerMutations']> = {
  addDoor?: Resolver<ResolversTypes['CloudControllerDoor'], ParentType, ContextType, RequireFields<CloudControllerMutationsAddDoorArgs, 'doorName'>>;
  identifyReader?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<CloudControllerMutationsIdentifyReaderArgs, 'doorId'>>;
  openDoor?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<CloudControllerMutationsOpenDoorArgs, 'doorId'>>;
  updateReaderFirmware?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<CloudControllerMutationsUpdateReaderFirmwareArgs, 'doorId'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudControllerQueriesResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloudControllerQueries'] = ResolversParentTypes['CloudControllerQueries']> = {
  getCloudController?: Resolver<ResolversTypes['CloudController'], ParentType, ContextType, RequireFields<CloudControllerQueriesGetCloudControllerArgs, 'cloudControllerId'>>;
  getCloudControllers?: Resolver<Array<ResolversTypes['CloudController']>, ParentType, ContextType>;
  getReaderFirmwareUpdate?: Resolver<Maybe<ResolversTypes['ReaderFirmwareUpdate']>, ParentType, ContextType, RequireFields<CloudControllerQueriesGetReaderFirmwareUpdateArgs, 'doorId'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CloudControllerReaderResolvers<ContextType = any, ParentType extends ResolversParentTypes['CloudControllerReader'] = ResolversParentTypes['CloudControllerReader']> = {
  cloudControllerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  doorId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  firmwareUpdate?: Resolver<Maybe<ResolversTypes['ReaderFirmwareUpdate']>, ParentType, ContextType>;
  serialNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DoorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Door'] = ResolversParentTypes['Door']> = {
  batteryWarningLevel?: Resolver<ResolversTypes['DoorBatteryWarningLevel'], ParentType, ContextType>;
  hardwareIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  locationIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  locations?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  officeMode?: Resolver<ResolversTypes['Schedule'], ParentType, ContextType>;
  supportsOssCards?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  taReaderId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DoorType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GuestResolvers<ContextType = any, ParentType extends ResolversParentTypes['Guest'] = ResolversParentTypes['Guest']> = {
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HostResolvers<ContextType = any, ParentType extends ResolversParentTypes['Host'] = ResolversParentTypes['Host']> = {
  azureId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  azureTenantId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  mobileDevices?: Resolver<Array<ResolversTypes['MobileDevice']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visitorGroupMembership?: Resolver<Array<ResolversTypes['VisitorGroupMembership']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IVisitResolvers<ContextType = any, ParentType extends ResolversParentTypes['IVisit'] = ResolversParentTypes['IVisit']> = {
  __resolveType: TypeResolveFn<'SubscriptionVisit' | 'Visit', ParentType, ContextType>;
  accepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  attendees?: Resolver<Array<ResolversTypes['Attendee']>, ParentType, ContextType>;
  dateEnd?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  dateStart?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  host?: Resolver<ResolversTypes['Host'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['VisitSource'], ParentType, ContextType>;
};

export type LegalDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalDocument'] = ResolversParentTypes['LegalDocument']> = {
  acceptedOn?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  acceptedVersion?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  currentText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  currentVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  documentType?: Resolver<ResolversTypes['LegalDocumentType'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = {
  doorIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  doors?: Resolver<Array<ResolversTypes['Door']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MobileDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['MobileDevice'] = ResolversParentTypes['MobileDevice']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRegistered?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  registrationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registrationToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  acceptLegalDocuments?: Resolver<ResolversTypes['AgreementResult'], ParentType, ContextType, RequireFields<MutationAcceptLegalDocumentsArgs, 'acceptedLegalDocuments'>>;
  addAndRemoveVisitorGroupMemberships?: Resolver<ResolversTypes['Visitor'], ParentType, ContextType, RequireFields<MutationAddAndRemoveVisitorGroupMembershipsArgs, 'visitorId'>>;
  addLocation?: Resolver<ResolversTypes['Location'], ParentType, ContextType, RequireFields<MutationAddLocationArgs, 'location'>>;
  addRestApiKey?: Resolver<ResolversTypes['RestApiKey'], ParentType, ContextType, RequireFields<MutationAddRestApiKeyArgs, 'description'>>;
  addVisitor?: Resolver<ResolversTypes['Visitor'], ParentType, ContextType, RequireFields<MutationAddVisitorArgs, 'name'>>;
  addVisitorGroup?: Resolver<ResolversTypes['VisitorGroup'], ParentType, ContextType, RequireFields<MutationAddVisitorGroupArgs, 'name' | 'type'>>;
  addVisitorsToVisitorGroup?: Resolver<ResolversTypes['VisitorGroup'], ParentType, ContextType, RequireFields<MutationAddVisitorsToVisitorGroupArgs, 'memberships' | 'visitorGroupId'>>;
  assignToAccessGrants?: Resolver<Array<ResolversTypes['AccessGrant']>, ParentType, ContextType, RequireFields<MutationAssignToAccessGrantsArgs, 'accessGrantIds' | 'doorIds' | 'locationIds'>>;
  blockNfcCard?: Resolver<ResolversTypes['NfcCard'], ParentType, ContextType, RequireFields<MutationBlockNfcCardArgs, 'reason' | 'uuid'>>;
  bulkAddVisitorsToVisitorGroups?: Resolver<ResolversTypes['BulkVisitorsPayload'], ParentType, ContextType, RequireFields<MutationBulkAddVisitorsToVisitorGroupsArgs, 'input'>>;
  bulkAssignVisitorRoles?: Resolver<ResolversTypes['BulkVisitorsPayload'], ParentType, ContextType, RequireFields<MutationBulkAssignVisitorRolesArgs, 'input'>>;
  bulkDeleteVisitors?: Resolver<ResolversTypes['BulkDeleteVisitorsPayload'], ParentType, ContextType, RequireFields<MutationBulkDeleteVisitorsArgs, 'input'>>;
  bulkResendVisitorInvitations?: Resolver<ResolversTypes['BulkVisitorsPayload'], ParentType, ContextType, RequireFields<MutationBulkResendVisitorInvitationsArgs, 'input'>>;
  cloudController?: Resolver<ResolversTypes['CloudControllerMutations'], ParentType, ContextType>;
  deleteDoorById?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationDeleteDoorByIdArgs, 'doorId'>>;
  deleteLocation?: Resolver<ResolversTypes['Location'], ParentType, ContextType, RequireFields<MutationDeleteLocationArgs, 'id'>>;
  deleteQrCodeVisit?: Resolver<ResolversTypes['QrCodeVisitWeb'], ParentType, ContextType, RequireFields<MutationDeleteQrCodeVisitArgs, 'qrCodeVisitId'>>;
  deleteRestApiKey?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationDeleteRestApiKeyArgs, 'id'>>;
  deleteVisitorById?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationDeleteVisitorByIdArgs, 'visitorId'>>;
  deleteVisitorGroupById?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType, RequireFields<MutationDeleteVisitorGroupByIdArgs, 'visitorGroupId'>>;
  goBackOneOnboardingStep?: Resolver<ResolversTypes['BasicTenant'], ParentType, ContextType>;
  onboardingChooseProvider?: Resolver<ResolversTypes['BasicTenant'], ParentType, ContextType, RequireFields<MutationOnboardingChooseProviderArgs, 'provider'>>;
  registerAzureTenant?: Resolver<ResolversTypes['RegisterAzureTenantResult'], ParentType, ContextType, RequireFields<MutationRegisterAzureTenantArgs, 'input'>>;
  resendVerificationCode?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationResendVerificationCodeArgs, 'email'>>;
  sendInvitationForMobileDeviceById?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationSendInvitationForMobileDeviceByIdArgs, 'mobileDeviceId' | 'visitorId'>>;
  setAccessGrantsIsOfficeModeEnabled?: Resolver<ResolversTypes['AccessGrant'], ParentType, ContextType, RequireFields<MutationSetAccessGrantsIsOfficeModeEnabledArgs, 'accessGrantId' | 'isOfficeModeEnabled'>>;
  setInstaller?: Resolver<ResolversTypes['Visitor'], ParentType, ContextType, RequireFields<MutationSetInstallerArgs, 'email' | 'name'>>;
  setIsAdminForGroup?: Resolver<ResolversTypes['VisitorGroup'], ParentType, ContextType, RequireFields<MutationSetIsAdminForGroupArgs, 'isAdmin' | 'visitorGroupId'>>;
  setIsQrCodeVisitInviterForGroup?: Resolver<ResolversTypes['VisitorGroup'], ParentType, ContextType, RequireFields<MutationSetIsQrCodeVisitInviterForGroupArgs, 'isQrCodeVisitInviter' | 'visitorGroupId'>>;
  setMfaPreference?: Resolver<ResolversTypes['UserMfaPreference'], ParentType, ContextType, RequireFields<MutationSetMfaPreferenceArgs, 'emailMfaEnabled'>>;
  setVisitor?: Resolver<ResolversTypes['Visitor'], ParentType, ContextType, RequireFields<MutationSetVisitorArgs, 'name'>>;
  setVisitorById?: Resolver<ResolversTypes['Visitor'], ParentType, ContextType, RequireFields<MutationSetVisitorByIdArgs, 'name' | 'visitorId'>>;
  unassignFromAccessGrants?: Resolver<Array<ResolversTypes['AccessGrant']>, ParentType, ContextType, RequireFields<MutationUnassignFromAccessGrantsArgs, 'accessGrantIds' | 'doorIds' | 'locationIds'>>;
  unregisterMobileDeviceById?: Resolver<ResolversTypes['ID'], ParentType, ContextType, RequireFields<MutationUnregisterMobileDeviceByIdArgs, 'mobileDeviceId' | 'visitorId'>>;
  unsetInstallerById?: Resolver<ResolversTypes['Visitor'], ParentType, ContextType, RequireFields<MutationUnsetInstallerByIdArgs, 'visitorId'>>;
  updateAccessGrant?: Resolver<ResolversTypes['AccessGrant'], ParentType, ContextType, RequireFields<MutationUpdateAccessGrantArgs, 'accessGrantId' | 'input'>>;
  updateDoor?: Resolver<ResolversTypes['Door'], ParentType, ContextType, RequireFields<MutationUpdateDoorArgs, 'doorId' | 'name'>>;
  updateLocation?: Resolver<ResolversTypes['Location'], ParentType, ContextType, RequireFields<MutationUpdateLocationArgs, 'id' | 'location'>>;
  updateMembership?: Resolver<ResolversTypes['VisitorGroupMembership'], ParentType, ContextType, RequireFields<MutationUpdateMembershipArgs, 'visitorGroupId' | 'visitorId'>>;
  updateRestApiKey?: Resolver<ResolversTypes['RestApiKey'], ParentType, ContextType, RequireFields<MutationUpdateRestApiKeyArgs, 'description' | 'id'>>;
  updateVisitorGroup?: Resolver<ResolversTypes['VisitorGroup'], ParentType, ContextType, RequireFields<MutationUpdateVisitorGroupArgs, 'name' | 'visitorGroupId'>>;
  updateVisitorGroupDetails?: Resolver<ResolversTypes['VisitorGroup'], ParentType, ContextType, RequireFields<MutationUpdateVisitorGroupDetailsArgs, 'input'>>;
  verifyAccount?: Resolver<ResolversTypes['BasicTenant'], ParentType, ContextType, RequireFields<MutationVerifyAccountArgs, 'code' | 'email'>>;
};

export type NfcCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['NfcCard'] = ResolversParentTypes['NfcCard']> = {
  assignment?: Resolver<Maybe<ResolversTypes['NfcCardAssignment']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updateRequired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uuid?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NfcCardAssignmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['NfcCardAssignment'] = ResolversParentTypes['NfcCardAssignment']> = {
  blocked?: Resolver<Maybe<ResolversTypes['BlockedInfo']>, ParentType, ContextType>;
  expired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  expiryDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  visitor?: Resolver<Maybe<ResolversTypes['Visitor']>, ParentType, ContextType>;
  visitorName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PersonResolvers<ContextType = any, ParentType extends ResolversParentTypes['Person'] = ResolversParentTypes['Person']> = {
  __resolveType: TypeResolveFn<'Guest' | 'Host', ParentType, ContextType>;
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type QrCodeVisitWebResolvers<ContextType = any, ParentType extends ResolversParentTypes['QrCodeVisitWeb'] = ResolversParentTypes['QrCodeVisitWeb']> = {
  datetime?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['AWSEmail']>, ParentType, ContextType>;
  host?: Resolver<ResolversTypes['Visitor'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['QrCodeVisitStatus']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  cloudController?: Resolver<ResolversTypes['CloudControllerQueries'], ParentType, ContextType>;
  getAccessEventsForTenant?: Resolver<ResolversTypes['AccessEventsPage'], ParentType, ContextType, Partial<QueryGetAccessEventsForTenantArgs>>;
  getCurrentTenant?: Resolver<ResolversTypes['BasicTenant'], ParentType, ContextType>;
  getCurrentVisitor?: Resolver<ResolversTypes['Visitor'], ParentType, ContextType>;
  getDoorsForTenant?: Resolver<Array<ResolversTypes['Door']>, ParentType, ContextType, Partial<QueryGetDoorsForTenantArgs>>;
  getLocationsForTenant?: Resolver<Array<ResolversTypes['Location']>, ParentType, ContextType, Partial<QueryGetLocationsForTenantArgs>>;
  getMfaPreference?: Resolver<ResolversTypes['UserMfaPreference'], ParentType, ContextType>;
  getNfcCards?: Resolver<Array<ResolversTypes['NfcCard']>, ParentType, ContextType>;
  getQrCodeVisitsForTenant?: Resolver<Array<ResolversTypes['QrCodeVisitWeb']>, ParentType, ContextType>;
  getRestApiKeys?: Resolver<Array<ResolversTypes['RestApiKey']>, ParentType, ContextType>;
  getTenantLegalDocuments?: Resolver<ResolversTypes['TenantLegalDocuments'], ParentType, ContextType>;
  getTenantName?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<QueryGetTenantNameArgs, 'azureTenantId'>>;
  getTenantRegistrationInfo?: Resolver<ResolversTypes['TenantRegistrationInfo'], ParentType, ContextType>;
  getVisitorById?: Resolver<ResolversTypes['Visitor'], ParentType, ContextType, RequireFields<QueryGetVisitorByIdArgs, 'id'>>;
  getVisitorGroupsForTenant?: Resolver<Array<ResolversTypes['VisitorGroup']>, ParentType, ContextType, Partial<QueryGetVisitorGroupsForTenantArgs>>;
  getVisitors?: Resolver<Array<ResolversTypes['Visitor']>, ParentType, ContextType, Partial<QueryGetVisitorsArgs>>;
};

export type ReaderFirmwareUpdateResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReaderFirmwareUpdate'] = ResolversParentTypes['ReaderFirmwareUpdate']> = {
  doorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['ReaderFirmwareUpdateStatus'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RegisterAzureTenantResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RegisterAzureTenantResult'] = ResolversParentTypes['RegisterAzureTenantResult']> = {
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RestApiKeyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RestApiKey'] = ResolversParentTypes['RestApiKey']> = {
  apiKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ScheduleResolvers<ContextType = any, ParentType extends ResolversParentTypes['Schedule'] = ResolversParentTypes['Schedule']> = {
  __resolveType: TypeResolveFn<'WeekSchedule', ParentType, ContextType>;
};

export type SubscriptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = {
  onMobileDeviceRegistered?: SubscriptionResolver<Maybe<ResolversTypes['SubscriptionMobileDevice']>, "onMobileDeviceRegistered", ParentType, ContextType, RequireFields<SubscriptionOnMobileDeviceRegisteredArgs, 'email'>>;
  onMobileDeviceRegisteredById?: SubscriptionResolver<Maybe<ResolversTypes['SubscriptionMobileDeviceById']>, "onMobileDeviceRegisteredById", ParentType, ContextType, RequireFields<SubscriptionOnMobileDeviceRegisteredByIdArgs, 'visitorId'>>;
  onReaderFirmwareUpdate?: SubscriptionResolver<Maybe<ResolversTypes['ReaderFirmwareUpdate']>, "onReaderFirmwareUpdate", ParentType, ContextType, RequireFields<SubscriptionOnReaderFirmwareUpdateArgs, 'doorId'>>;
  onRegistrationTokenSaved?: SubscriptionResolver<Maybe<ResolversTypes['SubscriptionRegistrationTokenSaved']>, "onRegistrationTokenSaved", ParentType, ContextType, RequireFields<SubscriptionOnRegistrationTokenSavedArgs, 'email'>>;
  onRegistrationTokenSavedById?: SubscriptionResolver<Maybe<ResolversTypes['SubscriptionRegistrationTokenSavedById']>, "onRegistrationTokenSavedById", ParentType, ContextType, RequireFields<SubscriptionOnRegistrationTokenSavedByIdArgs, 'visitorId'>>;
};

export type SubscriptionMobileDeviceResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionMobileDevice'] = ResolversParentTypes['SubscriptionMobileDevice']> = {
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>;
  registrationDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionMobileDeviceByIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionMobileDeviceById'] = ResolversParentTypes['SubscriptionMobileDeviceById']> = {
  mobileDeviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  registrationDate?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  visitorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionRegistrationTokenSavedResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionRegistrationTokenSaved'] = ResolversParentTypes['SubscriptionRegistrationTokenSaved']> = {
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>;
  registrationToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionRegistrationTokenSavedByIdResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionRegistrationTokenSavedById'] = ResolversParentTypes['SubscriptionRegistrationTokenSavedById']> = {
  mobileDeviceId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  registrationToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visitorId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionRemovedVisitResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionRemovedVisit'] = ResolversParentTypes['SubscriptionRemovedVisit']> = {
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionVisitResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionVisit'] = ResolversParentTypes['SubscriptionVisit']> = {
  accepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  attendees?: Resolver<Array<ResolversTypes['Attendee']>, ParentType, ContextType>;
  dateEnd?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  dateStart?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['AWSEmail'], ParentType, ContextType>;
  hasAttendees?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  host?: Resolver<ResolversTypes['Host'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isPastVisit?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['VisitSource'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantLegalDocumentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantLegalDocuments'] = ResolversParentTypes['TenantLegalDocuments']> = {
  dpa?: Resolver<ResolversTypes['LegalDocument'], ParentType, ContextType>;
  sla?: Resolver<ResolversTypes['LegalDocument'], ParentType, ContextType>;
  tenant?: Resolver<ResolversTypes['BasicTenant'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TenantRegistrationInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['TenantRegistrationInfo'] = ResolversParentTypes['TenantRegistrationInfo']> = {
  azureTenantId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  entraAdminConsentUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserMfaPreferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserMfaPreference'] = ResolversParentTypes['UserMfaPreference']> = {
  emailMfaEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisitResolvers<ContextType = any, ParentType extends ResolversParentTypes['Visit'] = ResolversParentTypes['Visit']> = {
  accepted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  attendees?: Resolver<Array<ResolversTypes['Attendee']>, ParentType, ContextType>;
  dateEnd?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  dateStart?: Resolver<ResolversTypes['AWSDateTime'], ParentType, ContextType>;
  host?: Resolver<ResolversTypes['Host'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['VisitSource'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisitorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Visitor'] = ResolversParentTypes['Visitor']> = {
  email?: Resolver<Maybe<ResolversTypes['AWSEmail']>, ParentType, ContextType>;
  expirationDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  externalRef?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  identityProvider?: Resolver<ResolversTypes['UserIdentityProvider'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEditable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isQrCodeVisitInviter?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  mobileDevices?: Resolver<Array<ResolversTypes['MobileDevice']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  visitorGroupMembership?: Resolver<Array<ResolversTypes['VisitorGroupMembership']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisitorGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitorGroup'] = ResolversParentTypes['VisitorGroup']> = {
  accessGrants?: Resolver<Array<ResolversTypes['AccessGrant']>, ParentType, ContextType>;
  allowedAccessGrants?: Resolver<Array<ResolversTypes['AccessGrant']>, ParentType, ContextType>;
  defaultAccessGrants?: Resolver<Array<ResolversTypes['AccessGrant']>, ParentType, ContextType>;
  externalRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAdminGroup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isQrCodeVisitInviterGroup?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  maxNumberOfMembers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  memberIds?: Resolver<Array<ResolversTypes['ID']>, ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['Visitor']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  scheduledAccessGrants?: Resolver<Array<ResolversTypes['AccessGrant']>, ParentType, ContextType>;
  tenantId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisitorGroupMembershipResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitorGroupMembership'] = ResolversParentTypes['VisitorGroupMembership']> = {
  expirationDate?: Resolver<Maybe<ResolversTypes['AWSDateTime']>, ParentType, ContextType>;
  role?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  visitorGroup?: Resolver<ResolversTypes['VisitorGroup'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VisitsPageResolvers<ContextType = any, ParentType extends ResolversParentTypes['VisitsPage'] = ResolversParentTypes['VisitsPage']> = {
  items?: Resolver<Array<ResolversTypes['Visit']>, ParentType, ContextType>;
  nextToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeekScheduleResolvers<ContextType = any, ParentType extends ResolversParentTypes['WeekSchedule'] = ResolversParentTypes['WeekSchedule']> = {
  weekDays?: Resolver<Array<ResolversTypes['WeekScheduleDay']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WeekScheduleDayResolvers<ContextType = any, ParentType extends ResolversParentTypes['WeekScheduleDay'] = ResolversParentTypes['WeekScheduleDay']> = {
  dayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  from?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AWSDate?: GraphQLScalarType;
  AWSDateTime?: GraphQLScalarType;
  AWSEmail?: GraphQLScalarType;
  AWSIPAddress?: GraphQLScalarType;
  AWSJSON?: GraphQLScalarType;
  AWSPhone?: GraphQLScalarType;
  AWSTime?: GraphQLScalarType;
  AWSTimestamp?: GraphQLScalarType;
  AWSURL?: GraphQLScalarType;
  AccessEvent?: AccessEventResolvers<ContextType>;
  AccessEventDoor?: AccessEventDoorResolvers<ContextType>;
  AccessEventVisitor?: AccessEventVisitorResolvers<ContextType>;
  AccessEventsPage?: AccessEventsPageResolvers<ContextType>;
  AccessGrant?: AccessGrantResolvers<ContextType>;
  AgreementRejected?: AgreementRejectedResolvers<ContextType>;
  AgreementResult?: AgreementResultResolvers<ContextType>;
  Attendee?: AttendeeResolvers<ContextType>;
  BasicTenant?: BasicTenantResolvers<ContextType>;
  BlockedInfo?: BlockedInfoResolvers<ContextType>;
  BulkDeleteVisitorsPayload?: BulkDeleteVisitorsPayloadResolvers<ContextType>;
  BulkOperationEntity?: BulkOperationEntityResolvers<ContextType>;
  BulkOperationError?: BulkOperationErrorResolvers<ContextType>;
  BulkVisitorsPayload?: BulkVisitorsPayloadResolvers<ContextType>;
  CloudController?: CloudControllerResolvers<ContextType>;
  CloudControllerDoor?: CloudControllerDoorResolvers<ContextType>;
  CloudControllerMutations?: CloudControllerMutationsResolvers<ContextType>;
  CloudControllerQueries?: CloudControllerQueriesResolvers<ContextType>;
  CloudControllerReader?: CloudControllerReaderResolvers<ContextType>;
  Door?: DoorResolvers<ContextType>;
  Guest?: GuestResolvers<ContextType>;
  Host?: HostResolvers<ContextType>;
  IVisit?: IVisitResolvers<ContextType>;
  LegalDocument?: LegalDocumentResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  MobileDevice?: MobileDeviceResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NfcCard?: NfcCardResolvers<ContextType>;
  NfcCardAssignment?: NfcCardAssignmentResolvers<ContextType>;
  Person?: PersonResolvers<ContextType>;
  QrCodeVisitWeb?: QrCodeVisitWebResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ReaderFirmwareUpdate?: ReaderFirmwareUpdateResolvers<ContextType>;
  RegisterAzureTenantResult?: RegisterAzureTenantResultResolvers<ContextType>;
  RestApiKey?: RestApiKeyResolvers<ContextType>;
  Schedule?: ScheduleResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubscriptionMobileDevice?: SubscriptionMobileDeviceResolvers<ContextType>;
  SubscriptionMobileDeviceById?: SubscriptionMobileDeviceByIdResolvers<ContextType>;
  SubscriptionRegistrationTokenSaved?: SubscriptionRegistrationTokenSavedResolvers<ContextType>;
  SubscriptionRegistrationTokenSavedById?: SubscriptionRegistrationTokenSavedByIdResolvers<ContextType>;
  SubscriptionRemovedVisit?: SubscriptionRemovedVisitResolvers<ContextType>;
  SubscriptionVisit?: SubscriptionVisitResolvers<ContextType>;
  TenantLegalDocuments?: TenantLegalDocumentsResolvers<ContextType>;
  TenantRegistrationInfo?: TenantRegistrationInfoResolvers<ContextType>;
  UserMfaPreference?: UserMfaPreferenceResolvers<ContextType>;
  Visit?: VisitResolvers<ContextType>;
  Visitor?: VisitorResolvers<ContextType>;
  VisitorGroup?: VisitorGroupResolvers<ContextType>;
  VisitorGroupMembership?: VisitorGroupMembershipResolvers<ContextType>;
  VisitsPage?: VisitsPageResolvers<ContextType>;
  WeekSchedule?: WeekScheduleResolvers<ContextType>;
  WeekScheduleDay?: WeekScheduleDayResolvers<ContextType>;
};

